module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day01_03_stay-32525d0111bb7e21c964b95d4f602263.jpg";